import { createContext } from "react";

export const TenantContext = createContext({
  tenant: {},
  setTenant: value => {},
});

export default TenantContext;